<template>
  <div class="absolute inset-0 pointer-events-none" v-bind:style="styles"></div>
</template>

<script>

export default {
  name: "PuzzleOverlayLayer",

  computed: {
    styles() {
      const puzzleSize = this.$root.print.size;
      const overlayUrl = this.$root.sizes.find(x => x.name === puzzleSize && x.material === 'puzzle').overlay;

      return {
        'background-image': 'url(\''+ overlayUrl + '\')',
        'background-size': 'contain',
        // 'transform': this.$root.print.orientation == 'horizontal' ? 'rotate(90deg)' : '',
      }
    }
  },

}
</script>

<style lang="scss" scoped>
</style>